import { useEffect, useState } from "react";
import axios from "axios";
import config from "../config";
import { getAlertCounts } from "../pages/alerts/AlertsApis";

const safeArray = (value) => (Array.isArray(value) ? value : []);

export default function useFleetOverviewLegacy(organizationId, onUnauthorized) {
  const [overview, setOverview] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      setLoading(true);
      try {
        const [vehicles, routes, stops, alertCounts, drivers, sites] = await Promise.all([
          axios.get(`${config.baseURL}/vehicle/organization`, { withCredentials: true }),
          axios.get(`${config.baseURL}/route/organization`, { withCredentials: true }),
          axios.get(`${config.baseURL}/stop/organization`, { withCredentials: true }),
          getAlertCounts(),
          axios.get(`${config.baseURL}/driver/organization?organizationId=${organizationId}`, {
            withCredentials: true,
          }),
          axios.get(`${config.baseURL}/site/organization?organizationId=${organizationId}`, {
            withCredentials: true,
          }),
        ]);

        const vehicleList = safeArray(vehicles.data);
        if (!isMounted) return;

        setOverview({
          vehicles: vehicleList.length,
          routes: safeArray(routes.data).length,
          stops: safeArray(stops.data).length,
          drivers: safeArray(drivers.data).length,
          sites: safeArray(sites.data).length,
          activeVehicles: vehicleList.filter((v) => v.status === "ACTIVE").length,
          inactiveVehicles: vehicleList.filter(
            (v) => v.status === "INACTIVE" || v.status === "DEAD" || !v.status,
          ).length,
          totalAlerts: alertCounts?.total || 0,
          vehicleAlerts: alertCounts?.byType?.VEHICLE || 0,
          userAlerts: alertCounts?.byType?.USER || 0,
          expiryAlerts: alertCounts?.byType?.EXPIRY || 0,
        });
      } catch (error) {
        if (error?.response?.status === 401 && onUnauthorized) {
          onUnauthorized();
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    if (organizationId) {
      fetchData();
    } else {
      setLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [organizationId, onUnauthorized]);

  return { overview, loading };
}
